module.exports = __webpack_public_path__ + "static/media/trash_can_w.0542235e.svg";